import axios from "axios";
import GlobalApi from "./index";

export default async function refreshToken() {
//   const promise = new Promise((resolve, reject) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let response = await axios
      .get(GlobalApi + "/refresh_token", {
        params: {
          refreshToken: data.refreshToken,
          id: data.user_id,
        },
      })
    //   .then(async function(response) {
        if(response.status !== "Success") {
          console.log(response);
          localStorage.removeItem("UserData");
          window.location.replace("/")
          return
        }
        let obj = {
            token: response.data.token,
            user_id: data.user_id,
          organization_id: data.organization_id,
          refreshToken: response.data.refreshToken,
        };
        console.log(obj);
        await localStorage.setItem("UserData", JSON.stringify(obj));
        // window.location.reload();
        return true
    //   })
    //   .catch(function(response) {
    //     console.log(response);
    //     return false
    //   });
//   });

//   return promise;
}
